import i18n from '@/i18n'
import UploadService from '@/services/upload.service'
import { mapActions } from 'vuex'
import { SnackbarStyle } from '@/constants/constants'
import { DialogMassiveUploadThing } from "@/tools/dialog"
import { filterRulesMapped } from '@/tools/filterRules'
import { thingService } from '@/services/thing.service'
import { clone } from 'ramda'

export default {
    name: 'MassiveUploadThingDialogComponent',
    components: {
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        // reglas de validación
        validationRules: {
            required: (value) => !!value || `${i18n.t('required')}`,
        },
        // model para el formulario
        validForm: false,
        // archivo seleccionado
        fileSelected: null,
        // errores del file-input
        fileErrors: [],
        // datos para las tablas
        tableDataKey: '_id',
        successTableHeaders: [],
        errorTableHeaders: [],
        tableFilterRules: {},
        success: [],
        error: [],
        // spinner
        loading: false,
        // tabs de las tablas
        tableTab: 'tab-1',
        // progreso de subida
        progress: 0,
        // tablas de información
        informationTableDataKey: '_id',
        activitiesTableHeaders: [],
        sectorsTableHeaders: [],
        typesTableHeaders: [],
        informationTableFilterRules: {},
        activities: [],
        sectors: [],
        types: [],
        informationLoading: false,
        // show information
        showInformation: false,
        // tabs de las tablas
        informationTableTab: 'tab-1'
    }),
    computed: {
    },
    created () {
    },
    mounted () {
    },
    methods: {
        /**
         * actions del snackbar
         */
        ...mapActions('snackbar', [
            'showSnackbar',
            'closeSnackbar'
        ]),
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pullBread',
            'pushBread'
        ]),
        /**
         * Resetea los campos del formulario
         */
        resetFields() {
            if (this.$refs.massiveUploadThingForm) {
                this.$refs.massiveUploadThingForm.reset()
            }
        },
        /**
         * Click fuera del dialog
         */
        clickOutside() {
            this.cancel()
        },
        /**
         * Cancelar
         */
        cancel() {
            this.pullBread(DialogMassiveUploadThing)
            this.resetFields()
        },
        /**
         * Guardar
         */
        async save() {
            this.progress = 0;
            this.loading = true
            UploadService.upload(this.model.file, event => {
                this.progress = Math.round((100 * event.loaded) / event.total);
            }).then(response => {
                    this.showSnackbar({ visible: true, text: this.$t('equipment.massiveUpload.done'), timeout: 6000, style: SnackbarStyle.SUCCESS })
                    this.success.cleanAndUpdate(response.data.success)
                    this.error.cleanAndUpdate(response.data.error)
                    this.successTableHeaders = clone(response.data.headers)
                    this.errorTableHeaders = clone(response.data.headers)
                    this.setTableFilterRules(response.data.headers)

                    // si hay errores y no hay éxitos, cambio de tab
                    if (this.success.length === 0 && this.error.length > 0) {
                        this.tableTab = 'tab-2'
                    }

                    this.loading = false
                    this.$emit('commitThing')
                })
                /*
                .catch(() => {
                    this.showSnackbar({ visible: true, text: this.$t('equipment.massiveUpload.uploadError'), timeout: 6000, style: SnackbarStyle.ERROR })
                    this.progress = 0;
                    this.loading = false
                    this.model.file = null;
                });
                */
        },
        /**
         * Reglas de filtrado de la tabla
         */
        setTableFilterRules(headers) {
            this.tableFilterRules = {}
            headers.forEach(header => {
                this.tableFilterRules[header.value] = filterRulesMapped[header.filterType]
            })
        },
        /**
         * Reglas de filtrado de las tablas de información
         */
        setInformationTableFilterRules(headers) {
            this.informationTableFilterRules = {}
            headers.forEach(header => {
                if (!this.informationTableFilterRules[header.value]) {
                    this.informationTableFilterRules[header.value] = filterRulesMapped[header.filterType]
                }
            })
        },
        /**
         * Cuando se sube un nuevo archivo en el file-input
         * @param {*} file
         */
        onFileSelected(file) {
            if (file) {
                this.model.file = file
            } else {
                this.model.file = null
                this.fileErrors = []
            }
        },
        /**
         * Muestra un dialog con información para la carga del csv
         * (keys de actividades, sectores y tipos)
         */
        async showInformationDialog() {
            this.showInformation = true
            this.informationLoading = true
            const informationData = await thingService.getMassiveUploadInformationData()
            this.activities.cleanAndUpdate(informationData.activities)
            this.types.cleanAndUpdate(informationData.types)
            this.sectors.cleanAndUpdate(informationData.sectors)
            this.activitiesTableHeaders = clone(informationData.headers.activities)
            this.typesTableHeaders = clone(informationData.headers.types)
            this.sectorsTableHeaders = clone(informationData.headers.sectors)
            this.setInformationTableFilterRules([...informationData.headers.activities, ...informationData.headers.types, ...informationData.headers.sectors])
            this.informationLoading = false
        }
    },
    watch: {
        /*
        model: {
            deep: true,
            immediate: true,
            handler: function (newModel) {
                if (newModel) {
                }
            }
        }
        */
    }
}
